import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { Portfolio } from './pages/Portfolio';
import { Artists } from './pages/Artists';
import { ArtistDetail } from './pages/ArtistDetail';
import { ArtistInterview } from './pages/ArtistInterview';
import { Shop } from './pages/Shop';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { BookNow } from './pages/BookNow';
import { ReleaseForm } from './pages/ReleaseForm';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Videos } from './pages/Videos';
import { NotFound } from './pages/NotFound';
export function App() {
  return <CartProvider data-id="element-0" data-mp="28sl32w6ujkeg">
      <BrowserRouter data-id="element-1" data-mp="28s2y9b64bxux">
        <Routes data-id="element-2" data-mp="23vkuoemiy5k6">
          <Route element={<Layout data-id="element-4" data-mp="23ujksdh8vp41" />} data-id="element-3" data-mp="23w4e5zrtp20b">
            <Route path="/" element={<Home data-id="element-6" data-mp="3ijxpcqos80jw" />} data-id="element-5" data-mp="23v2sl1d6kx4c" />
            <Route path="/portfolio" element={<Portfolio data-id="element-8" data-mp="3ij61k21ff746" />} data-id="element-7" data-mp="3ikhaeg9qb525" />
            <Route path="/artists" element={<Artists data-id="element-10" data-mp="3ml14faz09sk2" />} data-id="element-9" data-mp="3ihuyy5jpw5en" />
            <Route path="/artist/:slug" element={<ArtistDetail data-id="element-12" data-mp="3mjg93j4va5l5" />} data-id="element-11" data-mp="3mkhofzsx1e8o" />
            <Route path="/artist-interview" element={<ArtistInterview data-id="element-14" data-mp="3rcsxpt9jqcdw" />} data-id="element-13" data-mp="3rcj2nr9n9f1c" />
            <Route path="/shop" element={<Shop data-id="element-16" data-mp="6hovayao7c0" />} data-id="element-15" data-mp="3relw6la09qat" />
            <Route path="/product/:slug" element={<ProductDetail data-id="element-18" data-mp="82ovg3doih9" />} data-id="element-17" data-mp="4n4bxqxqh8g" />
            <Route path="/cart" element={<Cart data-id="element-20" data-mp="2zmepackaxs9m" />} data-id="element-19" data-mp="2zlle8zeb8glo" />
            <Route path="/book-now" element={<BookNow data-id="element-22" data-mp="33moqzd129wio" />} data-id="element-21" data-mp="2zmwhmy3ufmc9" />
            <Route path="/release-form" element={<ReleaseForm data-id="element-24" data-mp="33mykhalbelt4" />} data-id="element-23" data-mp="33lx0ggmbmoz9" />
            <Route path="/blog" element={<Blog data-id="element-26" data-mp="38li7lebna3n2" />} data-id="element-25" data-mp="38lrpeemjd4ho" />
            <Route path="/blog/:slug" element={<BlogPost data-id="element-28" data-mp="38o4edbqpof48" />} data-id="element-27" data-mp="38k6tolohjfi8" />
            <Route path="/videos" element={<Videos data-id="element-30" data-mp="3dlns8ajhypvn" />} data-id="element-29" data-mp="3dle3eqa6uorj" />
            <Route path="*" element={<NotFound data-id="element-32" data-mp="nvj3xh1mugq9" />} data-id="element-31" data-mp="3diruam7ng177" />
          </Route>
        </Routes>
      </BrowserRouter>
    </CartProvider>;
}